
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form19";
const form19State = namespace("Form19");

import Form19ProcessHeader from "@/components/process/Form19/components/Form19ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { form19StatusInfoType } from '@/types/Information/Form19';
import { packageInfoType } from '@/types/Information';

@Component({
    components:{
        Form19ProcessHeader,
        Spinner
    }
})
export default class SubmitForm19 extends Vue {

    @form19State.State
    public currentNoticeOfWithdrawalOfLawyerId: string;

    stepsCompleted = {} as form19StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }  

    public submit() {

        this.submitting = true;
        this.errorMsg =""

        const url = "/form19/efiling/"+this.currentNoticeOfWithdrawalOfLawyerId+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        this.$http.post(url, header)
        .then(res => {                            
            // this.submitting = false;
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
            }else
                this.submitting = false;
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.errorMsg = err.response.data.message
            else if(err.response?.data?.detail)
                this.errorMsg = err.response.data.detail+generalError
            else
                this.errorMsg = generalError
            this.submitting = false;
        });        
    }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
